<template>
    <div style="min-height: 200px;">
        <SearchUidOrPhone title="" style="margin-right: 16px;" @confirm="getUserInfo($event)"/>
        <div v-if="userForm" style="display: flex; align-items: center; padding: 24px; border: 1px solid #ededed;margin-top: 24px;">
            <HeadImg :images="userForm.headImg" />
            <div style="margin-left: 24px;">
                <p>昵称：{{ userForm.nickName }}<span style="color: red; margin-left: 8px;">{{ userForm.sex == 1?'男':userForm.sex == 2?'女':''}}</span> </p>
                <p>UID：{{ userForm.uid }}</p>
                <p>生日：{{ userForm.sysBirthday }}</p>
                <get-plain-dialog title="手机：" :code="userForm.phone" :uid="userForm.uid" :type="9" :subType="0"/>
            </div>
        </div>
        <div style="text-align:center; margin-top: 24px;" v-if="userForm">
            <el-button @click.native="cancel">返回</el-button>
            <el-button type="primary" @click.native="submit" v-loading="relationLoading">关联账号</el-button>
        </div>
    </div>
</template>

<script>
    import HeadImg from "../../../components/HeadImg";
    import Dialog from '@/assets/js/dialog'
    import GetPlainDialog from "@/components/resume/GetPlainDialog";
    import InfoImgDialog from "./InfoImgDialog";
    import SearchUidOrPhone from '@/components/SearchUidOrPhone'
    import { bindingUserImgInfo } from "../../../api/url";
    import { postFormData } from "../../../api/api";

    export default {
        components: { HeadImg, GetPlainDialog, SearchUidOrPhone },
        props: {
            value: Object
        },
        data() {
            return {
                id: this.value.id,
                userForm: null,
                relationLoading: false,
            }
        },
        methods: {
            cancel() {
                this.$emit('close')
            },

            getUserInfo(e) {
                console.log(e)
                this.userForm = e
            },

            submit() {
                let param = {
                    id: this.id,
                    userId: this.userForm.userId
                }
                this.relationLoading = true;
                postFormData(bindingUserImgInfo, param).then((data) => {
                    if(data.code == 200) {
                        this.$message({
                            showClose: true,
                            duration: 1000,
                            message: data.msg,
                            type: 'success'
                        })
                        this.$emit('confirm', this.userForm)
                    } else {
                        this.$message({
                            showClose: true,
                            duration: 1000,
                            message: data.msg,
                            type: 'warning'
                        })
                    }
                    this.relationLoading = false;
                })
                    .catch(() => {
                        this.relationLoading = false;
                    })
            }
        }
    }
</script>

<style>

</style>
